import {accountInfo} from "../constants/constants";
import {GET_MY_NOTIFICATION_API} from "../constants/api_constants";
import {mobileInterface} from "../pages/WindowInterfaces";
import neverLandUtils from "./NeverLandUtils";
import {getFetcherNotification} from "./fetcher_notification";
import neverLandDirectMessage from "./NeverLandDirectMessage";


// let config_mapping_events=[
//   {config: 'on_request_register' , events: ['navigate:store/storerequestlist','navigate:user/requestlist']},
//   {config: 'on_request_print' , events: ['navigate:store/storerequestlist','navigate:user/requestlist']},
// ];

let config_mapping_events=[
  {config: 'on_notification_all' , events: {tags:['target-all','timing-all'],default:true, volume:3}},
  {config: 'on_store_confirm' , events: {tags:['target-user','timing-approval_complete'],default:false, volume:3}},
  {config: 'on_confirm_request' , events: {tags:['target-store','timing-approval_request'],default:false, volume:3}},
  {config: 'on_request_register' , events: {tags:['target-store','timing-betting'],default:false, volume:3}},
  {config: 'on_request_print' , events: {tags:['target-user','timing-change'],default:false, volume:3}},
];

const _onNotificationMessagingEnd = (neverLandNotificationInterface, notificationActions) => {
  if (notificationActions.includes('navigate:user/relogin')) {
    if (neverLandNotificationInterface.event.onRelogin) {
      neverLandNotificationInterface.event.onRelogin();
    }
  }

  if (notificationActions.includes('action:utils/reload')) {
    window.location.reload();
  }
}
const _onNotificationMessaging = (neverLandNotificationInterface, info, notificationAction, message, type) => {

  if (type === 'on-received') {
    // TODO: 백엔드에서 메세지 이모탈 / 일반 메세지(휘발성 ex:팡 정보 변경 등)를 구분해줘야됨
    if (notificationAction.includes('display:user/message:immortal')) {
      // 등록 시간과 상관없이 보여줌
      if (neverLandNotificationInterface.event.onDisplayMessage) {
        neverLandNotificationInterface.event.onDisplayMessage(message);
      }
    }
    if (notificationAction.includes('display:user/message')) {
      // 30초 이내에 들어온것만 보여주기
      // let timeout=new Date().getTime()/1000 - info.registedNotificationDate;
      // if (timeout < 30) {
      //   console.log(timeout+"/"+info.registedNotificationDate+"/"+ new Date().getTime()+"/ liveMessage -> " + message);
      //   if (neverLandNotificationInterface.event.onDisplayMessage) {
      //     neverLandNotificationInterface.event.onDisplayMessage(message);
      //   }
      // } else {
      //   console.log(timeout+"/"+info.registedNotificationDate+"/"+ new Date().getTime()+"/ deadMessage -> " + message);
      // }
    }
    return;
  }
  if (type === 'on-touch') {
    // toast.success(message);
    return;
  }
}

class NeverLandNotificationInterface {
  interval;
  playSound;
  checkSoundOption;
  getSoundVolume;

  event = {
    onRelogin: null,
    onDisplayMessage: null
  };

  _notificationStatus = null;

  notificationData = null;

  onNotificationHandlers = [];

  _delay = 3500;
  isSuspend = false;

  registMonitor(monitorInfo, onNotificationHandler) {
    let notificationTarget = "programKey:" + monitorInfo.programKey + "/accountKey:" + monitorInfo.accountKey + "/notifyKey:" + monitorInfo.notifyKey;
    let json = {
      onNotificationHandler: onNotificationHandler,
      monitorInfo: monitorInfo,
      notificationTarget: notificationTarget
    };
    this.onNotificationHandlers.push(json);

    if (this.notificationData !== null)
      this._isNotificationContains(json, this.notificationData.myNotificationList);
  }

  unRegistMonitor(onNotificationHandler) {
    this.onNotificationHandlers = this.onNotificationHandlers.filter((o) => o.onNotificationHandler !== onNotificationHandler);
  }

  destroy() {
    let _int = this.interval;
    this.interval = null;
    if (_int) {
      clearInterval(_int);
    }
  }

  //{programKey:programKey,notifyKey: notifyKey,accountKey: accountKey}

  _isNotificationContains(onNotificationHandler, thisList) {
    if (thisList.length === 0)
      return;

    let temp = {onNotificationHandler: onNotificationHandler.onNotificationHandler, list: []};
    for (let n of thisList) {
      if (n.notificationTarget === onNotificationHandler.notificationTarget) {
        temp.list.push(n);
      }
    }
    try {
      temp.onNotificationHandler(temp.list);
    } catch {
    }
  }

  _onNotificationChanged(newList, useAlarmSound, alarmVolume) {
    if (newList.length === 0)
      return;

    if (useAlarmSound && this.playSound && alarmVolume>0) {
      this.playSound(alarmVolume);
    }

    let tempList = [];
    for (let onNotificationHandler of this.onNotificationHandlers) {
      let temp = {onNotificationHandler: onNotificationHandler.onNotificationHandler, list: []};
      for (let n of newList) {
        if (n.notificationTarget === onNotificationHandler.notificationTarget) {
          temp.list.push(n);
        }
      }
      if (temp.list.length > 0) {
        tempList.push(temp);
      }
    }
    if (tempList.length > 0) {
      for (let temp of tempList) {
        try {
          temp.onNotificationHandler(temp.list);
        } catch {
        }
      }
    }
  }

  constructor() {
    if (!NeverLandNotificationInterface.instance) {
      this._notificationStatus = {
        last_notification_time: 0
      };
      NeverLandNotificationInterface.instance = this;
    }
    return NeverLandNotificationInterface.instance;

  }


  commitNotifications(notifyKey) {
    // 눌렀을 때 알림 지우기
    if (!accountInfo.isLogin())
      return;
    if (this.notificationData === null) {
      this.notificationData = neverLandUtils.commons.load("notificationData");
    }
    if (this.notificationData === null) {
      this.notificationData = {myNotificationList: [], lastReceivedNotificationDate: 0};
    }
    notifyKey = "/notifyKey:" + notifyKey + "/";
    this.notificationData.myNotificationList = this.notificationData.myNotificationList.filter((o) => {
          if (!(o.notificationTarget + "/").includes(notifyKey)) {
            return true;
          }
          _onNotificationMessaging(this, o, o.notificationAction, o.notificationMessageDetails, 'on-touch');
          return false;
        }
    );

    for (let m of this.onNotificationHandlers) {
      if ((m.notificationTarget + "/").includes(notifyKey)) {
        try {
          m.onNotificationHandler([]);
        } catch {
        }
      }
    }
    neverLandUtils.commons.save("notificationData", this.notificationData);
  }

  getCurrentNotifications(currentJson) {
    if (this.notificationData === null)
      return [];
    let notificationTarget = "programKey:" + currentJson.programKey + "/accountKey:" + currentJson.accountKey + "/notifyKey:" + currentJson.notifyKey;
    let thisList = this.notificationData.myNotificationList;
    if (thisList.length === 0)
      return [];
    let temp = [];
    for (let n of thisList) {
      if (n.notificationTarget === notificationTarget) {
        temp.push(n);
      }
    }
    return temp;
  }

  onNotification(newNotificationJson) {
    if (newNotificationJson === null)
      return;
    let useAlarmSound = false;
    this.notificationData.lastReceivedNotificationDate = newNotificationJson.lastReceivedNotificationDate;
    let newList = [...this.notificationData.myNotificationList];

    function getTimeText(isoString) {
      const date = new Date(isoString);

      return `${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
    }

    if (newNotificationJson.myNotificationList.length > 0) {
      let alarmVolume=0;
      for (let notificationData of newNotificationJson.myNotificationList) {
        if (notificationData.notificationMessageType === 'direct-message') {
          let details = notificationData.notificationMessageDetails.split('|');
          if (details.length > 2) {
            neverLandDirectMessage.appendNewMessage(details[0], details[1].replace('<sep/>', '|'), getTimeText(details[2]));
          }
          continue;
        }
        newList.push(notificationData);
        if (this.checkSoundOption !== undefined) {
          let target=notificationData.targeter;
          let alarmTiming=notificationData.alarmTiming;
          if (this.checkSoundOption(notificationData.notificationTarget, notificationData.targeter, notificationData.alarmTiming)) {
            useAlarmSound = true;
            if(this.getSoundVolume!==undefined) {
              alarmVolume = Math.max(alarmVolume, this.getSoundVolume(notificationData.notificationTarget, notificationData.targeter, notificationData.alarmTiming));
            }
            else{
              alarmVolume=100;
            }
          }
        } else {
          useAlarmSound = true;
          alarmVolume=100;
        }
      }
      this.notificationData.myNotificationList = newList;
      neverLandUtils.commons.save("notificationData", this.notificationData);
      this._onNotificationChanged(newList, useAlarmSound,alarmVolume);
    }
  }

  start() {
    if (this.interval) {
      return;
    }
    setTimeout(() => {
      _onInterval();
      this.interval = setInterval(_onInterval, 1500)
    }, 1000);
  }

  getDelay() {
    return this._delay;
  }

  _mobileNotificationKey = "";
  _notiConfigScript="none";

  setNotificationKeyForApp(accountId, accountSessionCode) {
    let _notiKey = "";
    if (accountId !== -1) {
      let _lastReceivedNotificationDate = this.notificationData.lastReceivedNotificationDate;
      if (_lastReceivedNotificationDate === null) {
        _lastReceivedNotificationDate = -1;
      }
      //"userId=23&sessionCode=1601:2128872655|lastReceivedNotificationDate"
      _notiKey = "userId=" + accountId + "&sessionCode=" + accountSessionCode + "|" + _lastReceivedNotificationDate;
    }
    if (this._mobileNotificationKey === _notiKey) {
      return;
    }
    this._mobileNotificationKey = _notiKey;
    mobileInterface.debug('setNotificationKeyForApp->' + _notiKey);
    mobileInterface.mobile_actionCommand("notificationKey", _notiKey);
    this.setNotificationConfig(this._notiConfigScript);

  }


  setNotificationConfig(notiConfigScript){
    if(mobileInterface.mobile_actionCommand===undefined)
      return;


    if(notiConfigScript===this._notiConfigScript)
      return;

    this._notiConfigScript= notiConfigScript;

    let _config_mapping_events=config_mapping_events;

    let temp="";


    let isOn=false;
    let volume=0;



    for(let rule  of _config_mapping_events) {
        isOn = rule.events.default;
        volume = rule.events.volume;

        if (this._notiConfigScript.includes(rule.config + '":true')) {
          isOn = true;
        } else if (this._notiConfigScript.includes(rule.config + '":false')) {
          isOn = false;
        }

        if (!isOn) {
          temp = _tagsToString(temp, rule.events.tags, '!');
        }
        else{
          let findConfigKey=rule.config + '_volume":';
          let index=this._notiConfigScript.indexOf(findConfigKey);
          if(index!==-1){
            volume = parseInt(this._notiConfigScript.substr(index+ findConfigKey.length, 1));
          }
          temp  = _tagsToString(temp, rule.events.tags, '')+":"+volume;
        }
    }
    if(notiConfigScript.includes("\"on_mute\":true")){temp+="|[on_mute]"; }
    console.log('mobile_actionCommand->notificationConfig::'+temp);

    mobileInterface.mobile_actionCommand("notificationConfig", temp);
  }

  pushNotificationsByScript(value) {
    console.log('pushNotificationsByScript', value);
    let _raw_data = getDataList(value);
    let json = {
      result: {
        myNotificationList: [],
        lastReceivedNotificationDate: -1
      }
    };
    let lastReceivedNotificationDate = -1;
    for (let item of _raw_data) {
      let tempDate = item[1];
      json.result.myNotificationList.push({
        notificationTarget: item[0],
        registedNotificationDate: tempDate,
        notificationMessageType: item[2],
        notificationMessageDetails: item[3],
        notificationAction: item[4],
        targeter: item[5],
        alarmTiming: item[6],
      });
      lastReceivedNotificationDate = Math.max(Number(tempDate) + 1, lastReceivedNotificationDate);
    }
    json.result.lastReceivedNotificationDate = lastReceivedNotificationDate;
    neverLandNotificationInterface.onNotification(getNotificationJson(accountInfo.accountId(), json));
  }
}
function _tagsToString(origin, tags, head) {
  let temp='';

  for(let t of tags){
    if(temp.length>0){
      temp=temp+"&";
    }
    temp+=t;
  }
  if(temp.length===0){
    return origin;
  }
  if(origin.length===0){
    return head+"["+temp+"]";
  }
  return origin+"|"+head+"["+temp+"]";
}
function getDataList(currentValue) {
  let tokens = currentValue.split("▒");
  let result = [];
  let temp;

  for (let index = 0; index < tokens.length; index++) {
    temp = tokens[index].replaceAll('\n','').split("|");
    temp = encodeData(temp);
    result.push(temp);
  }
  return result;
}

function encodeData(tokens) {
  let temp;
  for (let index = 0; index < tokens.length; index++) {
    temp = tokens[index];
    temp = temp.replaceAll("<sep/>", "|").replaceAll("<br/>", "\n");
    tokens[index] = temp;
  }
  return tokens;
}

const _onInterval = () => {
  if (neverLandNotificationInterface._notificationStatus === null)
    return;
  let now = new Date().getTime();
  if (now - neverLandNotificationInterface._notificationStatus.last_notification_time < neverLandNotificationInterface.getDelay()) {
    return;
  }
  neverLandNotificationInterface._notificationStatus.last_notification_time = now;
  try {
    getMyNotification();
  } catch {
  }
}

const getMyNotification = () => {
  if (!accountInfo.isLogin()) {
    neverLandNotificationInterface.notificationData = null;
    if (mobileInterface.isMobile()) {
      neverLandNotificationInterface.setNotificationKeyForApp(-1);
    }
    return true;
  }
  if (neverLandNotificationInterface.notificationData === null) {
    neverLandNotificationInterface.notificationData = neverLandUtils.commons.load("notificationData");
  }
  if (neverLandNotificationInterface.notificationData === null) {
    neverLandNotificationInterface.notificationData = {myNotificationList: [], lastReceivedNotificationDate: 0};
  }
  if (mobileInterface.isMobile()) {
    neverLandNotificationInterface.setNotificationKeyForApp(accountInfo.accountId(), accountInfo.accountSessionCode());
  }
  if (neverLandNotificationInterface.isSuspend) {
    return;
  }
  // 내 알람정보 가져오기
  getFetcherNotification().get(accountInfo.makeGetRequestSpecial(GET_MY_NOTIFICATION_API) +
      `&lastReceivedNotificationDate=${neverLandNotificationInterface.notificationData.lastReceivedNotificationDate}`)
      .then((res) => {
        try {
          neverLandNotificationInterface.onNotification(getNotificationJson(accountInfo.accountId(), res.data));
        } catch (err) {
          console.log("getMyNotification-->err1", err);
        }
      })
      .catch((err) => {
        console.log("getMyNotification-->err2", err);
      })
  return true;
}


const getNotificationJson = (accountKey, json) => {
  if (json.result.myNotificationList.length === 0) {
    neverLandNotificationInterface._delay = Math.min(5500, neverLandNotificationInterface._delay + 350);
    return null;
  }
  neverLandNotificationInterface._delay = 2500;
  // 실시간으로 알림 받기
  let result = {
    myNotificationList: json.result.myNotificationList
    , lastReceivedNotificationDate: json.result.lastReceivedNotificationDate
  };
  let actions = [];
  for (let noti of result.myNotificationList) {
    // WindowInterfaces.notificationTarget();
    // TODO: 토스트말고 화면에 메세지 띄우기
    // toast.success(noti.notificationMessageDetails);

    if (!actions.includes(noti.notificationAction)) {
      actions.push(noti.notificationAction);
    }



    try {
      _onNotificationMessaging(neverLandNotificationInterface, noti, noti.notificationAction, noti.notificationMessageDetails, 'on-received');
    } catch (err) {
      console.log("getNotificationJson-->err", err);
    }

    noti.notificationTarget = getNotificationTargetMapping(accountKey, noti.notificationTarget);
  }

  try {
    _onNotificationMessagingEnd(neverLandNotificationInterface, actions);
  } catch (err) {
    console.log("getNotificationJson-->err", err);
  }

  actions = null;


  if (mobileInterface.isMobile())
  {
    let tempNotifications = {};

    for (let noti of result.myNotificationList) {
      tempNotifications[noti.notificationAction] = {
                message: noti.notificationMessageDetails,
                targeter: noti.targeter,
                timing: noti.alarmTiming };
      //
      // tempNotifications[noti.notificationAction] = {message: noti.notificationMessageDetails,
      //   targeter: 'test',timing: 'test'};
    }

    for (let [key, value] of Object.entries(tempNotifications)) {
      let currentTiming=value.timing;
      mobileInterface.mobile_notification(key, "normal", value.message, value.targeter, currentTiming);
    }

    tempNotifications = null;
  }
  return result;
}

const getNotificationTargetMapping = (accountKey, notificationTarget) => {
  if (notificationTarget.includes("store/customermanagement")) {
    return "programKey:mobydick/accountKey:" + accountKey + "/notifyKey:request_confirm_for_store_owner"
  }
  if (notificationTarget.includes("store/storerequestlist")) {
    return "programKey:mobydick/accountKey:" + accountKey + "/notifyKey:order_list_for_store"
  }
  if (notificationTarget.includes("user/requestlist")) {
    return "programKey:mobydick/accountKey:" + accountKey + "/notifyKey:order_list"
  }
  if (notificationTarget.includes("user/mystore")) {
    return "programKey:mobydick/accountKey:" + accountKey + "/notifyKey:response_confirm_of_my_store"
  }
  return notificationTarget;
}
const neverLandNotificationInterface = new NeverLandNotificationInterface();
export default neverLandNotificationInterface;

